import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchCampaigns } from '@/lib/venue/campaignApi'
import type { CampaignListFilter } from '@/lib/venue/campaignViewModel'

export function campaignsQueryKey(venueId: string, filter: CampaignListFilter) {
  return ['venue', venueId, 'campaigns', filter] as const
}

/**
 * 이력 목록(#714 §1-5, #728 §4) — 서버가 이미 인코딩된 `nextCursor`를 주므로 `useVenueReservations`와
 * 같은 방식으로 `getNextPageParam`을 직접 선언한다(`lib/api/cursor.ts`의 opaque-cursor 헬퍼는 쓰지 않는다).
 */
export function useCampaigns(venueId: string, filter: CampaignListFilter) {
  return useInfiniteQuery({
    queryKey: campaignsQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) => fetchCampaigns(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
